import React from "react";

function BackgroundSection({ imageName, children }) {
    
  
    return (
      <section  className={`bg-[url(../img/bg-${imageName}.png)] bg-cover bg-no-repeat bg-center relative pt-12 pb-24`}>
        <div className="container">{children}</div>
      </section>
    );
  };

export default BackgroundSection;